module.exports = __webpack_public_path__ + "static/media/3.65c08d85.png";